import React from 'react';
import './Header.css';
const Header = ({children}) => (
  <div className="headerTitle">
    {children}
  </div>
)


export default Header;